export const checkPermission = (subscription, uid, permissions) => {
    /*console.log("c-permissions ", permissions);
    console.log("c-subscription ", subscription);
    console.log("c-uid ", uid);*/
    let allow = false;
    for(let i=0; i<permissions.length; i++){
        if(subscription.permissions && subscription.permissions[permissions[i]]){
            if(subscription.permissions[permissions[i]].indexOf(uid) >= 0){
                allow = true;
            }
        }
    }
    if(subscription.ownerId === uid){
        allow = true;
    }
    return allow;
}
